import { render } from "./Multimedia.vue?vue&type=template&id=28b95c6d&scoped=true"
import script from "./Multimedia.vue?vue&type=script&lang=js"
export * from "./Multimedia.vue?vue&type=script&lang=js"

import "./Multimedia.vue?vue&type=style&index=0&id=28b95c6d&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b95c6d"]])

export default __exports__